var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var Link = require('react-router').Link;

var Pagination = createReactClass({

	getListNodes: function(){
		var listNodes = [];

		for(var i = 1; i <= this.props.totalPageNum; i++){
			if(i === this.props.currentPageNum){
				listNodes.push(<li key={i} className="current"><span className="show-for-sr">You're on page</span> {i}</li>);
			}else{
				listNodes.push(<li key={i}><Link to={this.props.baseUrl + '/' + i} aria-label={'Page ' + i}>{i}</Link></li>);
			}
		}

		var limit = 5;
		if(listNodes.length > limit){
			if(this.props.totalPageNum - this.props.currentPageNum < Math.ceil(limit/2)){
				listNodes = listNodes.slice(-limit);
			}else{
				listNodes = listNodes.splice(Math.max(this.props.currentPageNum - Math.floor(limit/2) - 1, 0), limit);
			}
		}

		if(this.props.currentPageNum === 1){
			listNodes.unshift(<li key="previous" className="pagination-previous disabled"><span className="show-for-sr">Previous page</span></li>);
		}else{
			listNodes.unshift(<li key="previous" className="pagination-previous"><Link to={this.props.baseUrl + '/' + (this.props.currentPageNum - 1)} aria-label="Next page"><span className="show-for-sr">Previous page</span></Link></li>);
		}

		if(this.props.currentPageNum === this.props.totalPageNum){
			listNodes.push(<li key="next" className="pagination-next disabled"><span className="show-for-sr">Next page</span></li>);
		}else{
			listNodes.push(<li key="next" className="pagination-next"><Link to={this.props.baseUrl + '/' + (this.props.currentPageNum + 1)} aria-label="Next page"><span className="show-for-sr">Next page</span></Link></li>);
		}

		return listNodes;
	},

	render: function () {
        return (
			<ul className="pagination text-center" role="navigation" aria-label="Pagination">
				{this.getListNodes()}
			</ul>
        );
    }
});

Pagination.propTypes = {
  currentPageNum: PropTypes.number.isRequired,
  totalPageNum: PropTypes.number.isRequired,
  baseUrl: PropTypes.string.isRequired
};

module.exports = Pagination;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/pagination.jsx